module.exports = __webpack_public_path__ + "static/media/carte-madagascar.1e7a1d46.svg_old";